<template>
  <div id="InvoiceDetail">
    <el-divider></el-divider>
    <el-form
      :model="formData"
      ref="formDataRef"
      style="text-align:left;margin-left:50px;margin-bottom:20px"
    >
      <!-- 发票类型 -->
      <el-form-item :label="$t('orderManagement.invoiceType')+$t('common.colon')"
        ><span>{{ formData.invoiceType }}</span></el-form-item
      >
      <!-- 发票抬头 -->
      <el-form-item :label="$t('orderManagement.invoiceTitle')+$t('common.colon')"
        ><span>{{ formData.invoiceHeader }}</span></el-form-item
      >
      <!-- 入账总额 -->
      <el-form-item :label="$t('orderManagement.totalAmount')+$t('common.colon')">
        <span
          >{{ formData.entryPrice }}&nbsp;{{ formData.currency }}</span
        ></el-form-item
      >
      <!-- 服务项目 -->
      <el-form-item :label="$t('orderManagement.serviceItems')+$t('common.colon')"
        ><span>{{ $t("orderManagement.trainingFees") }}</span></el-form-item
      >
      <!-- 纳税人识别号 -->
      <el-form-item :label="$t('orderManagement.TaxpayeridentifyNo')+$t('common.colon')"
        ><span>{{ formData.taxpayerIdentificationNumber }}</span>
      </el-form-item>
      <!-- 公司注册地址 -->
      <el-form-item :label="$t('orderManagement.companyRegistAdd')+$t('common.colon')"
        ><span>{{ formData.registeredAddress }}</span></el-form-item
      >
      <!-- 公司财务电话 -->
      <el-form-item :label="$t('orderManagement.CorporateFinancialTel')+$t('common.colon')"
        ><span>{{ formData.companyFinancialTelephone }}</span>
      </el-form-item>
      <!-- 开户银行 -->
      <el-form-item :label="$t('orderManagement.bankOfDeposit')+$t('common.colon')"
        ><span>{{ formData.bankName }}</span></el-form-item
      >
      <!-- 银行账号 -->
      <el-form-item :label="$t('orderManagement.bankAccountNo')+$t('common.colon')"
        ><span>{{ formData.bankAccount }}</span></el-form-item
      >
      <!-- 领取方式 -->
      <el-form-item :label="$t('orderManagement.wayOfReceive')+$t('common.colon')"
        ><span>{{
          formData.collectionMethod === "0" ? $t("orderManagement.expressDelivery") : $t("orderManagement.electron")
        }}</span></el-form-item
      >
      <!-- 收件人姓名 -->
      <el-form-item :label="$t('orderManagement.recipientnName')+$t('common.colon')"
        ><span>{{ formData.recipientName }}</span></el-form-item
      >
      <!-- 联系电话 -->
      <el-form-item :label="$t('orderManagement.contactNo')+$t('common.colon')"
        ><span>{{ formData.recipientTelephone }}</span></el-form-item
      >
      <!-- 邮递地址 -->
      <el-form-item
        :label="
          formData.collectionMethod === '1'
            ? $t('orderManagement.email1')+$t('common.colon')
            : $t('orderManagement.postalAdd')+$t('common.colon')
        "
      >
        <span v-if="formData.collectionMethod === '1'">{{
          formData.recipientEmail
        }}</span>
        <span v-else>
          {{
            stringIfNull(formData.province) +
              stringIfNull(formData.city) +
              stringIfNull(formData.area) +
              stringIfNull(formData.detailedAddress)
          }}</span
        >
      </el-form-item>
      <!-- 备注 -->
      <el-form-item :label="$t('orderManagement.remarks')+$t('common.colon')"
        ><span>{{ formData.remarks }}</span></el-form-item
      >
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // 页面载入状态
      pageLoading: false,
      // 页面数据
      formData: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    async init() {
      this.formData = {};
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#InvoiceDetail")
      });
      let url = "/api/orderManagement/getInvoiceDetail";
      await this.$http
        .post(url, {
          orderId: this.$props.orderId
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.formData = {};
            } else {
              // 渲染页面
              this.formData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    stringIfNull(val) {
      if (val !== null) {
        return val;
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.blueDivider {
  display: inline-block;
}

.blueDivider >>> .el-divider--vertical {
  background-color: #00b0f0;
}

.foot-container {
  margin: 100px auto 0 auto;
  height: 26px;
  width: 50%;
  text-align: center;
}

>>> .el-dialog__body {
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding: 10px 20px;
  overflow-y: auto;
}
>>> .el-divider--horizontal {
  margin: 14px 0;
}
>>> .el-form-item {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Asqms/views/OrderManagement/InvoiceDetail.vue